export default function createEncodedUrlParamsFromObject(params = {}){
    let queryString = Object?.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
    
    return `?${queryString}`;
}
